export const DirectionEnum = Object.freeze({
    previous: 'previous',
    next: 'next'
});